import { boot } from 'quasar/wrappers'
import VueClickAway from 'vue3-click-away'

export default boot(({ app }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - COMBAK FIXME incompatible with latest vue version?
  app.use(VueClickAway)
})
